import { Injectable } from '@angular/core'
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http'
import { Observable, from, switchMap, catchError } from 'rxjs'

import { environment } from '../../../environments/environment'
import { SKIP_GENERIC_ERROR_SNACKBAR } from '../../interceptors/http.interceptor'
import { throwIfCustomError } from '../../util/throwIfCustomError'
import { FirebaseTokenProvider } from '../roleplay/active-session-count.service'

/** 統合エクスポート API へのリクエストパラメータ */
export interface IntegratedAssessmentExportParams {
  startDate: Date | null
  endDate: Date | null
  skillMapIds: string[]
}

/** 統合アセスメントエクスポート API サービス */
@Injectable({ providedIn: 'root' })
export class IntegratedAssessmentExportService {
  private readonly baseUrl = environment.graphqlUrl.replace(/\/$/, '')

  constructor(
    private readonly http: HttpClient,
    private readonly tokenProvider: FirebaseTokenProvider,
  ) {}

  /**
   * 統合エクスポート API に GET リクエストを送り Blob レスポンスを返す
   * @param params エクスポート条件（日付範囲・スキルマップID）
   */
  exportIntegratedAssessments(
    params: IntegratedAssessmentExportParams,
  ): Observable<HttpResponse<Blob>> {
    return from(this.tokenProvider.getIdToken()).pipe(
      switchMap((token: string) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        })

        const queryParams = new URLSearchParams()
        if (params.startDate) {
          queryParams.set('startDate', params.startDate.toISOString())
        }
        if (params.endDate) {
          queryParams.set('endDate', params.endDate.toISOString())
        }
        queryParams.set('skillMapIds', params.skillMapIds.join(','))

        const url = `${this.baseUrl}/api/export/integrated-assessments?${queryParams.toString()}`

        return this.http.get(url, {
          headers,
          context: new HttpContext().set(SKIP_GENERIC_ERROR_SNACKBAR, true),
          responseType: 'blob',
          observe: 'response',
        })
      }),
      catchError((error: unknown) => {
        throwIfCustomError(error)
        throw error
      }),
    )
  }
}
